<template>
  <div id="alert-summary">
    <div id="monitoring-vessel-engine-header">
      <div id="header-text" class="sdf-text-22-700-white">
        アラートサマリー
      </div>
      <div class="vessel-communication-channel-area">
        <vessel-communication-channel />
      </div>
    </div>
    <div id="alert-data-details">
      <div id="side-container">
        <div class="alert-title-text sdf-text-20-400-white">現在のアラート</div>
      </div>
      
      <div id="main-container">
        <div class="data-report-menu-area">
          <div class="alert-count">
            <template v-if="alertLength > 0">
              <span class="alert-count-number sdf-text-30-400-red">{{alertLength}}</span>
              <span class="alert-count-text sdf-text-20-400-white">件の異常が発生しています</span>
            </template>
            <template v-else>
              <span class="alert-count-text sdf-text-20-400-white">異常は発生していません</span>
            </template>
          </div>
          <div class="data-report-menu-item" @click="openPopup3d">
            <feather-icon
              icon="ApertureIcon"
              svgClasses="h-5 w-5"
              class="mr-2 menu-item-icon"
            /><p class="sdf-text-16-400-white">機関室警報3D表示</p>
          </div>
          <div class="data-report-menu-item" @click="callDownloadCsv">
            <feather-icon
              icon="FileTextIcon"
              svgClasses="h-5 w-5"
              class="mr-2 menu-item-icon"
            /><p class="sdf-text-16-400-white">CSVダウンロード</p>
          </div>
        </div>
        <div>
          <div id="chart-column-header" class="sdf-text-14-400-mouse-gray">
            <div class="column-header-text column-check">
              <vs-checkbox @click="checkClicked" v-model="checkAll" :color="sdfColor.Blue"></vs-checkbox>
            </div>
            <div class="column-header-text column-date">発生日時</div>
            <div class="column-header-text column-id">ID</div>
            <div class="column-header-text column-alert-name">アラート名</div>
          </div>
          <engine-data-alert-summary
            ref="child"
            @updateAlertLength="updateAlertLength"
            @initialiseAlertHistory="initialiseAlertHistory"
          >
          </engine-data-alert-summary>
        </div>
      </div>
      <sdf-popup class="no-select-popup" :popupActive.sync="popupActiveNoSelect">
        <p style="margin: 30px 0px;">
          ダウンロードしたいチャンネルの左側のボックスをチェックしてください
        </p>
        <vs-button class="popup-button" :color="sdfColor.MouseGray" :style="popupButtonStyle" @click="popupActiveNoSelect = false">閉じる</vs-button>
      </sdf-popup>
      <sdf-popup class="display-3d-popup" :popupActive.sync="popupActive3d">
        <template v-slot:title>
          <feather-icon
            icon="ApertureIcon"
            svgClasses="h-6 w-6"
            class="mr-2 menu-item-icon"
          />
          <p class="popup-title sdf-text-20-400-white">機関室警告3D表示</p>
        </template>
        <vs-input
          v-model="inputChannelNumber"
          class="popup-input"
          placeholder="CH Noを入力"
        ></vs-input>
        <vs-button
          class="popup-button sdf-text-18-400-white"
          :color="sdfColor.Blue"
          :style="popupButtonStyle3d"
          @click="callDownloadCsv3d()"
        >ダウンロード
        </vs-button>
        <vs-button
          class="popup-button sdf-text-18-400-white"
          :color="sdfColor.MouseGray"
          :style="popupButtonStyle3d"
          @click="openFitViewer()"
        >3D表示する
        </vs-button>
      </sdf-popup>
    </div>
  </div>

</template>

<script>
import EngineDataAlertSummary from "./components/EngineDataAlertSummary";
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin"
import SecureDataflowService from "@/services/secureDataflowService";
import SdfPopup from "../components/SdfPopup";
import VesselCommunicationChannel from "../components/VesselCommunicationChannel";
import moment from "moment"
import Vue from "vue";
import {createNamespacedHelpers} from "vuex"
import {
  StoreCommonsMixin,
  StoreMenuMixin,
  MappingTableMixin,
  StoreMonitoringVesselManeuveringMixin
} from "@/mixins/addon/secure-dataflow";
const { mapGetters, mapActions, mapState } = createNamespacedHelpers("monitoringVesselEngine");

export default {
  name: "alertSummary",
  mixins: [
    StoreCommonsMixin,
    StoreMenuMixin,
    SecureDataflowMixin,
    MappingTableMixin,
    StoreMonitoringVesselManeuveringMixin
  ],
  components: {
    EngineDataAlertSummary,
    SdfPopup,
    VesselCommunicationChannel
  },
  data() {
    return {
      popupActive: false,
      popupButtonStyle: `
        padding: 2px 36px !important;
      `,
      popupActive3d: false,
      popupButtonStyle3d: `
        padding: 5px !important;
        margin-right: 15px;
      `,
      popupActiveNoSelect: false,
      inputChannelNumber: "",
      checkAll: false,
      alertLength: 0,

      intervalId: null,
      timer: null,
      timerSBX: null,
      timerAMS: null,
      maneuveringLastUpdatedAt: null,
      maneuveringLastUpdateAtString: null,
      engineLastUpdatedAt: null,
      lastUpdateAt: null,
    }
  },
  watch: {
    checkAll() {
      if (this.checkAll) {
        this.$refs.child.checkAll();
      } else {
        this.$refs.child.checkClear();
      }
    },

    channelDataManeuvering(val) {
      if(!val) return
      if (val.last_updated_at) {
        this.maneuveringLastUpdatedAt = moment.unix(
          val.last_updated_at.seconds
        );
        this.setWatchConnectionStateSBX();  // SB-Xの通信状態監視
        //timerAMSリセットを防ぐため一旦コメントアウト
        //if (this.engineLastUpdatedAt) this.setWatchConnectionStateAMS();  // AMSの通信状態監視
        this.updateStateTime();
      }
    },
    channelDataEngine(val) {
      if(!val) return
      if (val.last_updated_at) {
        this.engineLastUpdatedAt = moment.unix(val.last_updated_at.seconds);
        //timerSBXリセットを防ぐため一旦コメントアウト
        //if (this.maneuveringLastUpdatedAt) this.setWatchConnectionStateSBX();  // SB-Xの通信状態監視
        this.setWatchConnectionStateAMS();  // AMSの通信状態監視
        this.updateStateTime();
      }
    },
    async isIdle() {
      let r = this.$router.resolve({
        name: "login-enterprise",
        query: { logout: "force" }
      });
      window.location.assign(r.href)
    }
  },
  computed: {
    ...mapGetters(["getAlertSummaryData", "getVersion"]),
    ...mapState({
      mode: state => state.mode,
      liveDataTimeRange: state => state.liveDataTimeRange,
      alertSummaryLiveDatas: state => state.alertSummaryLiveDatas,
      unsubscribes: state => state.unsubscribes,
      unsubscribesForChart: state => state.unsubscribesForChart,
    }),

    operationMode() {
      if (this.channelDataManeuvering) {
        return `${this.getOperationModeLabel(
          this.channelDataManeuvering.SB44.vs
        )}`;
      }
    },
    isIdle() {
			return this.$store.state.idleVue.isIdle;
		}
  },
  methods: {
    ...mapActions([
      "initializeCustomChannelIds",
      "downloadCsv",
      "download3dCsv",
      "setLatestVersion",
      "setModeState",
      "setChannelTimeFromState",
      "setChannelTimeToState",
      "resetAlertSummaryLiveDatas",
      "setChannelsDataSearchedByStatus",
      "addAlertOccurTime",
      "resetAlertOccurTime",
      "setNotFoundAlertOccurTime"
    ]),
    /**
     * 過去24時間分のエラー発生日時を検索
     */
    async initialiseAlertHistory() {
      let time_from = null;
      let time_to = null;

      let liveDataTimeRange = 60 * 24;
      time_from = moment().subtract(liveDataTimeRange, "minutes").toISOString();
      time_to   = moment().toISOString();

      await this.setChannelTimeFromState(time_from);
      await this.setChannelTimeToState(  time_to);

      this.$nextTick(async () => {
        await this.setModeState("live");
        await this.searchAlertEventHistory();
      });
    },
    /**
     * アラート発生時のデータを取得
     */
    async searchAlertEventHistory() {
      // チャンネルタイムは残す、発生時間にチャンネルタイムを使う
      let alertChannelList = this.$refs.child.alertList.map(element => {
        return {
          channel_id: element.channelId,
          channel_time: element.localTime
        }
      }).filter(element => element.channel_id != null)
      if (alertChannelList.length == 0) return // アラート状態のチャンネルがない場合何もしない
      
      let payload = {
        status_contains: ["E"],
        channel_group: "alert",
        channel_ids: alertChannelList.map(element => element.channel_id)
      }
      await this.setChannelsDataSearchedByStatus(payload);

      // APIから取得したアラートサマリーチャンネルデータを時間順にソート
      // findで一番最初に見つけたチャンネルデータを最新のデータとし、発生時間マップに登録
      let data = [...this.getAlertSummaryData]
      let sortedAlertSummaryData = await data.sort(function (a, b) {
        return moment(b.channel_time).valueOf() - moment(a.channel_time).valueOf()
      })

      alertChannelList.forEach(element => {
        let latestData = sortedAlertSummaryData.find(target => {
          return target.channel_id == element.channel_id
        })
        // APIから取得したデータに該当のチャンネルデータがなければ、
        // firestoreのチャンネルデータを発生時間として発生時間マップに登録
        if (latestData) {
          this.addAlertOccurTime(latestData)
          // 最新時間が見つかったアラートをリストから除外
          alertChannelList = alertChannelList.filter(alert => alert.channel_id != latestData.channel_id)
        }
      })

      // リストから除外されていないアラートを対象に再度時間を広げて検索を行う
      if (alertChannelList.length > 0) { // 全ての発生時間が見つからなかった場合
        let liveDataTimeRangeFrom = 60 * 24 * 7;
        let liveDataTimeRangeTo = 60 * 24;
        const time_from = moment().subtract(liveDataTimeRangeFrom, "minutes").toISOString();
        const time_to   = moment().subtract(liveDataTimeRangeTo, "minutes").toISOString();

        await this.setChannelTimeFromState(time_from);
        await this.setChannelTimeToState(  time_to);

        payload = {
          status_contains: ["E"],
          channel_group: "alert",
          channel_ids: alertChannelList.map(element => element.channel_id)
        }
        await this.setChannelsDataSearchedByStatus(payload);

        // APIから取得したアラートサマリーチャンネルデータを時間順にソート
        // findで一番最初に見つけたチャンネルデータを最新のデータとし、発生時間マップに登録
        data = [...this.getAlertSummaryData]
        sortedAlertSummaryData = await data.sort(function (a, b) {
          return moment(b.channel_time).valueOf() - moment(a.channel_time).valueOf()
        })

        alertChannelList.forEach(element => {
          let latestData = sortedAlertSummaryData.find(target => {
            return target.channel_id == element.channel_id
          })
          // APIから取得したデータに該当のチャンネルデータがなければ、
          // firestoreのチャンネルデータを発生時間として発生時間マップに登録
          if (latestData) {
            this.addAlertOccurTime(latestData)
          } else {
            this.setNotFoundAlertOccurTime(element)
          }
        })
      }
    },

    updateAlertLength(value) {
      this.alertLength = value
    },
    openPopup3d() {
      this.popupActive3d = true;
      let checkedChannels = this.$refs.child.checkedChannels;
      this.inputChannelNumber = checkedChannels["engine"].join();
    },
    checkClicked() {
      this.$refs.child.checkAll();
    },
    async callDownloadCsv() {
      let checkedChannels = this.$refs.child.checkedChannels;
      let channelListWithVersion = [];
      let version = this.getVersion;
      Object.keys(checkedChannels).forEach(key => {
        checkedChannels[key].forEach(channelId => {
          channelListWithVersion.push({
            version_id: version[key].versionId,
            channel_id: channelId,
          });
        });
      });
      if (channelListWithVersion.length != 0) {
        const vessel = await SecureDataflowService.getVessel();
        let now = moment().utc().format("YYYY-MM-DDTHH:mm:ss") + ".000Z";

        let liveDataTimeRange = this.liveDataTimeRange ? this.liveDataTimeRange : 60;
        let liveTimeFrom = moment().utc().subtract(liveDataTimeRange, "minutes").format("HH:mm:ss");
        let liveDateTimeFrom = moment().utc().subtract(liveDataTimeRange, "minutes").format("YYYY-MM-DD") + "T" + liveTimeFrom + ".000Z";

        let time_from = this.mode === "live" ? liveDateTimeFrom : this.getChannelTimeFrom;
        let time_to = this.mode === "live" ? now : this.getChannelTimeTo;

        let payload = {
          vessel_id: vessel.vessel_info.id,
          body: {
            channel_time_from: time_from,
            channel_time_to: time_to,
            channels: channelListWithVersion,
          }
        }
        try {
          let res = await this.downloadCsv(payload);
          const blob = new Blob([res.data], { type: "text/csv" });
          const uri = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = `data.csv`;
          link.href = uri;
          link.click();
          this.$vs.loading.close();
        } catch (e) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "ダウンロードに失敗しました",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square"
          });
        }
      } else {
        this.popupActiveNoSelect = true
      }
    },
    async callDownloadCsv3d() {
      if (this.inputChannelNumber.length != 0) {
        let version = this.getVersion;
        let kind = "engine";
        let channelList = this.inputChannelNumber.split(',');
        const vessel = await SecureDataflowService.getVessel();

        let now = moment().utc().format("YYYY-MM-DDTHH:mm:ss") + ".000Z";

        let liveDataTimeRange = this.liveDataTimeRange ? this.liveDataTimeRange : 60;
        let liveTimeFrom = moment().utc().subtract(liveDataTimeRange, "minutes").format("HH:mm:ss");
        let liveDateTimeFrom = moment().utc().subtract(liveDataTimeRange, "minutes").format("YYYY-MM-DD") + "T" + liveTimeFrom + ".000Z";

        let time_from = this.mode === "live" ? liveDateTimeFrom : this.getChannelTimeFrom;
        let time_to = this.mode === "live" ? now : this.getChannelTimeTo;

        let payload = {
          vessel_id: vessel.vessel_info.id,
          body: {
            origin: version[kind].originId,
            kind: kind,
            version_id: version[kind].versionId,
            channel_time_from: time_from,
            channel_time_to: time_to,
            channel_ids: channelList,
          }
        };
        try {
          let res = await this.download3dCsv(payload);
          const blob = new Blob([res.data], { type: "text/csv" });
          const uri = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = `alarm_data.csv`;
          link.href = uri;
          link.click();
          this.$vs.loading.close();
        } catch (e) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "ダウンロードに失敗しました",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square"
          });
        }
      }
    },
    openFitViewer() {
      this.popupActive3d = false;
      window.open('fitviewer:', '_blank');
    },
    updateStateTime() {
      // 最終更新時刻は操船データの最終更新時刻を採用
      if (this.maneuveringLastUpdatedAt) {
        this.maneuveringLastUpdateAtString = this.maneuveringLastUpdatedAt
          .local()
          .format("YYYY/MM/DD HH:mm:ss");
      } else {
        this.maneuveringLastUpdateAtString = "--/--/-- --:--:--";
      }
      
      if (this.maneuveringLastUpdatedAt && this.engineLastUpdatedAt) {
        if (this.maneuveringLastUpdatedAt.isAfter(this.engineLastUpdatedAt)) {
          this.lastUpdateAt = this.maneuveringLastUpdatedAt;
        } else {
          this.lastUpdateAt = this.engineLastUpdatedAt;
        }
        this.setWatchConnectionState();
      }
    },
    setWatchConnectionState() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.isDisconnect()) {
        this.setDisconnectState4gVSAT()
      } else {
        // Vue.$log.info(
        //   `[SDF] Stable 4G/VSA connection, last update at ${this.lastUpdateAt.local()}`
        // );
        this.SET_CONNECTING_STATE_4G_VSAT({
          isDisconnect: false,
          localTime: this.lastUpdateAt.local()
        });
        this.setTimerWatchConnectionState();
      }
    },
    setWatchConnectionStateSBX() {
      if (this.timerSBX) {
        clearTimeout(this.timerSBX);
        this.timerSBX = null;
      }
      if (this.isDisconnectManeuvering()) {
        this.setDisconnectStateSBX();
      } else {
        // Vue.$log.info(
        //   `[SDF] Stable SBX connection, last update at ${this.maneuveringLastUpdatedAt.local()}`
        // );
        this.SET_CONNECTING_STATE_SBX({
          isDisconnect: false,
          localTime: this.maneuveringLastUpdatedAt.local()
        });
        this.setTimerWatchConnectionStateSBX();
      }
    },
    setWatchConnectionStateAMS() {
      if (this.timerAMS) {
        clearTimeout(this.timerAMS);
        this.timerAMS = null;
      }
      if (this.isDisconnectEngine()) {
        this.setDisconnectStateAMS();
      } else {
        // Vue.$log.info(
        //   `[SDF] Stable AMS connection, last update at ${this.engineLastUpdatedAt.local()}`
        // );
        this.SET_CONNECTING_STATE_AMS({
          isDisconnect: false,
          localTime: this.engineLastUpdatedAt.local()
        });
        this.setTimerWatchConnectionStateAMS();
      }
    },
    setTimerWatchConnectionState() {
      this.timer = setTimeout(() => {
        this.setDisconnectState4gVSAT()
      }, 60000 * 2);
    },
    setTimerWatchConnectionStateSBX() {
      this.timerSBX = setTimeout(() => {
        this.setDisconnectStateSBX()
      }, 60000 * 2);
    },
    setTimerWatchConnectionStateAMS() {
      this.timerAMS = setTimeout(() => {
        this.setDisconnectStateAMS()
      }, 60000 * 2);
    },
    isDisconnect() {
      // 2分超えているかどうか
      return moment().diff(this.lastUpdateAt, "minutes") >= 2;
    },
    isDisconnectManeuvering() {
      // SB-Xデータ不到達判定: 2分超えているかどうか
      return moment().diff(this.maneuveringLastUpdatedAt, "minutes") >= 2;
    },
    isDisconnectEngine() {
      // AMSデータ不到達判定: 2分超えているかどうか
      return moment().diff(this.engineLastUpdatedAt, "minutes") >= 2;
    },
    setDisconnectState4gVSAT() {
      Vue.$log.warn(
        `[SDF] Disconnect 4G/VSAT, last update at ${this.lastUpdateAt.local()}`
      );
      this.SET_CONNECTING_STATE_4G_VSAT({
        isDisconnect: true,
        localTime: this.lastUpdateAt.local()
      });
    },
    setDisconnectStateSBX() {
      Vue.$log.warn(
        `[SDF] Disconnect SB-X, last update at ${this.maneuveringLastUpdatedAt.local()}`
      );
      this.SET_CONNECTING_STATE_SBX({
        isDisconnect: true,
        localTime: this.maneuveringLastUpdatedAt.local()
      });
    },
    setDisconnectStateAMS() {
      Vue.$log.warn(
        `[SDF] Disconnect AMS, last update at ${this.engineLastUpdatedAt.local()}`
      );
      this.SET_CONNECTING_STATE_AMS({
        isDisconnect: true,
        localTime: this.engineLastUpdatedAt.local()
      });
    }
  },
  mounted() {
    this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", "secureDataflow");
    let routerViewClass = document.getElementsByClassName("router-view");
    routerViewClass[0].style.padding = "0.0rem";
  },
  async created() {
    await this.resetAlertSummaryLiveDatas();

    await this.setLatestVersion()

    let vessel = await SecureDataflowService.getVessel();
    if (typeof vessel === "undefined") {
      this.SET_SHOW_DIALOG_SELECT_VESSEL(true)
    } else {
      let payload = {
        vesselInfo: vessel.vessel_info,
        maneuveringOriginId: vessel.maneuvering_origin_id,
        engineOriginId: vessel.engine_origin_id,
        alertOriginId: vessel.alert_origin_id,
      };
      await this.setVesselInfoAndVersions(payload);
    }

    await this.getInitialFOFlow({
      vesselId: this.vesselInfo.id,
      versionName: this.engineVersion.name
    })

    await this.subscribeChannelDataManeuvering({
      vesselId: this.vesselInfo.id,
      versionName: this.maneuveringVersion.name
    });

    await this.subscribeChannelDataEngine({
      vesselId: this.vesselInfo.id,
      versionName: this.engineVersion.name
    });

    await this.subscribeChannelDataAlert({
      vesselId: this.vesselInfo.id,
      versionName: this.alertVersion.name
    });

    //setTimeout(() => {this.initialiseAlertHistory()}, 6000);
    
  },
  beforeDestroy() {
    this.resetStateOfMonitoringVesselManeuvering();
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (this.timerSBX) {
      clearTimeout(this.timerSBX);
    }
    if (this.timerAMS) {
      clearTimeout(this.timerAMS);
    }
    this.resetAlertOccurTime();
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/secure-dataflow/_variables.scss";
#monitoring-vessel-engine-header {
  width: 100%;
  height: 83px;
  background: #09151C;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
  align-items: center;
}

#header-text {
  margin-left: 120px;
}

#alert-summary {
  background-color: $dark-blue-navy;
  min-height: calc(100vh);
  .vessel-communication-channel-area {
    margin-right: 40px;
  }
}

#alert-data-details{
  color: $white;
  display: flex;
  #side-container {
    width: 250px;
    padding: 30px;
  }

  .alert-title-text {
    min-width: 220px;
  }

  .menu-item-icon {
    position: absolute;
    margin-top: 3px;
  }

  .alert-count {
    margin-right: auto;
    .alert-count-number {
      margin-right: 10px;
    }
  }

  .effect {
    background: $blue !important;
  }
  .vs-pagination--buttons {
    background: transparent !important;
    color: $white;
  }

  .vs-pagination--ul {
    background: $navy;
  }
  .vs-pagination--li {
    color: $white;
  }

  #main-container {
    width: 100%;
    padding-left: 30px;
  }
  .control-area {
    display: flex;
  }
  .data-report-menu-area {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 80px;
  }

  .data-report-menu-item {
    margin: 20px;
    cursor: pointer;
    p {
      font-size: 16px;
      padding-left: 29px;
    }
  }

  .side-switch {
    margin-top: 20px;
    margin-bottom: 30px;
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
    width: 120px;
  }
  .side-switch-area {
    margin-top: 40px;
  }
  .side-menu-item {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
  .engine-data-chart-container {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  #chart-column-header {
    display: flex;
    border-bottom: solid;
    border-width: 1px;
    border-color: $gray;
  }

  .column-check {
    padding-left: 13px;
    min-width: 60px;
  }
  .column-alerm {
    min-width: 70px;
  }
  .column-channel-id {
    min-width: 60px;
  }
  .column-channel-name {
    width: 220px;
  }
  .column-value {
    min-width: 180px;
  }
  .column-unit {
    min-width: 80px;
  }
  .column-status {
    min-width: 80px;
  }
  .column-chart {
    min-width: 220px;
  }
  .column-date {
    min-width: 210px;
  }
  .column-id {
    min-width: 120px;
  }
  .column-alert-name, .column-event-name {
    min-width: 600px;
  }
  .column-alert-value, .column-event-value {
    min-width: 120px;
  }
  .column-alert-status, .column-event-status {
    min-width: 130px;
  }
  .column-3d {
    min-width: 100px;
  }
  .pagination {
    float: right;
  }
  .item-disabled {
    cursor: default;
    color: #888888;
    p {
      color: #888888;
    }
  }
  .display-3d-popup {
    .button-3d {
      padding: 0px 13px !important;
      border-radius: 15px;
    }
    .popup-input {
      margin-top: 30px;
      margin-bottom: 30px;
      margin-right: 30px;
      width: auto;
      input {
        background: transparent;
        border-color: $white !important;
      }
      .vs-input--placeholder {
        color: $white;
      }
    }
    .popup-title {
      margin-left: 30px;
    }
    .popup-button {
      padding: 5px !important;
    }
    .sdf-popup-container {
      width: 350px;
    }
  }
}

</style>
